import React from 'react'
import { Button, Slider, message } from 'antd'
import { SliderValue } from 'antd/es/slider'
import Icon, { CaretRightOutlined, PauseOutlined, LoadingOutlined } from '@ant-design/icons'
import * as SvgIcon from '../../../assets/icon'
import './index.less'

type PlayStatusType = 'playing' | 'paused' | 'loading'

export interface AudioPlayProps {
	src: string;
	getAudio?: (...args: any[]) => any;
	onError?: () => void;
}

export interface AudioPlayState {
	volume: number;
	canPlay: boolean;
	playStatus: PlayStatusType;
}

const playStatusIconMap = {
	playing: <PauseOutlined />,
	paused: <CaretRightOutlined />,
	loading: <LoadingOutlined />,
}

class AudioPlay extends React.Component<AudioPlayProps, AudioPlayState> {

	state: AudioPlayState = {
		volume: 80, // [0, 100]
		canPlay: false,
		playStatus: 'paused',
	}

	audioDom: HTMLAudioElement | null = null // 将dom暴露给外部
	audio: HTMLAudioElement = new Audio()

	componentDidUpdate(prevProps: AudioPlayProps) {
		if (prevProps.src === this.props.src) return
		if (!this.props.src) { // 音频链接清空
			this.pause()
		}
		if (!prevProps.src && this.props.src) { // 初始化获得值
			this.init()
		}
	}

	componentWillUnmount() {
		if (this.audio) {
			this.pause()
		}
	}

	/**
	 * 初始化
	 */
	init = (props: AudioPlayProps = this.props) => {
		const { src } = props
		if (!props.src) return
		this.audio.preload = 'automatic'
		this.audio.src = src
		this.audio.load()

		// 音频是否可播放
		this.audio.oncanplay = () => {
			this.setState({
				canPlay: true,
			})
		}

		// 播放结束
		this.audio.onended = () => {
			this.setState({ playStatus: 'paused' })
		}

		// 音频加载失败
		this.audio.onerror = () => {
			message.error('音频加载失败！请重试')
			this.pause()
			this.props.onError && this.props.onError()
		}
	}

	/**
	 * 播放
	 */
	play = () => {
		this.audio.play()
		this.setState({
			playStatus: 'playing',
		})
	}

	/**
	 * 暂停
	 */
	pause = () => {
		this.audio.pause()
		this.setState({
			playStatus: 'paused',
		})
	}

	/**
	 * 调节音量
	 */
	onVolumeChange = (val: SliderValue) => {
		if (typeof val === 'number') {
			this.setState({ volume: val })
			this.audio.volume = val / 100 // 音量取值范围[0, 1]
		}
	}

	onBtnClick = () => {
		const { playStatus } = this.state
		const { src, getAudio } = this.props
		if (!src) { // 初始 获取音频链接
			if (getAudio) {
				this.setState({ playStatus: 'loading' })
				getAudio().then(() => {
					message.success('文字转音频成功')
					this.setState({ playStatus: 'paused' })
				}).catch(() => {
					message.error('文字转音频失败！请重试')
					this.setState({ playStatus: 'paused' })
				})
			}
			return
		}

		switch (playStatus) { // 切换播放状态
		case 'paused':
			this.play()
			break
		case 'playing':
			this.pause()
			break
		}
	}

	render() {
		const { playStatus, volume } = this.state
		const icon = playStatusIconMap[playStatus]
		return (
			<div className="audio-play-wrap">
				<Button
					className="control-btn"
					type="primary"
					style={{marginRight: '20px'}}
					onClick={this.onBtnClick}
				>
					{this.props.src
						? icon
						: (playStatus === 'loading' ? icon : '试听')
					}
				</Button>

				{/* 音量调节 */}
				{(playStatus === 'playing') && (<div className="volume-control">
					<Icon component={SvgIcon.VolumeLow} onClick={() => this.onVolumeChange(0)} />
					<Slider value={volume} tipFormatter={(value) => `${value}%`} onChange={this.onVolumeChange} />
					<Icon component={SvgIcon.VolumeLound} onClick={() => this.onVolumeChange(100)} />
				</div>)}
			</div>
		)
	}
}

export default AudioPlay